import React, {FC, useRef, useState} from 'react';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {AsyncHandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {PopoverProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverTypes';
import {AnswerModel} from '../../../../models/api/answerModel';
import {HtmlEditorBoxHandle} from '../../../common/boxedInputs/htmlEditorBox';
import {HtmlEditorBoxContainer} from '../../../common/boxedInputs/htmlEditorBoxContainer';
import {AnswerDialogBase, AnswerDialogValues} from './answerDialogBase';

/*
 * Props.
 */

export interface HtmlAnswerDialogProps extends PopoverProps {
  initialCleanHtml: string;
  namespace: string;
  onCreateClick: AsyncHandlerOf<AnswerDialogValues, AnswerModel>;
}

/*
 * Component.
 */

export const HtmlAnswerDialog: FC<HtmlAnswerDialogProps> = (props) => {
  const {initialCleanHtml, onCreateClick, ...otherProps} = props;
  const editorRef = useRef<HtmlEditorBoxHandle>(null);
  const [hasValidBodyValue, setHasValidBodyValue] = useState(initialCleanHtml.trim().length > 0);
  const [hasBodyChanged, setHasBodyChanged] = useState(false);

  const onBodyChange = (isEmpty: boolean) => {
    if (!hasBodyChanged) {
      setHasBodyChanged(true);
    }

    setHasValidBodyValue(!isEmpty);
  };

  const buildBodyValue = () => {
    const editor = editorRef.current;
    if (!editor) {
      throw new Error('Missing HTML editor box handle');
    }

    return editor.cleanHtml;
  };

  return (
    <AnswerDialogBase
      {...otherProps}
      hasValidBodyValue={hasValidBodyValue}
      onCreateClick={(values) => onCreateClick({...values, body: buildBodyValue()})}
      hasBodyChanged={hasBodyChanged}
    >
      {(bodyProps) => (
        <HtmlEditorBoxContainer
          {...bodyProps}
          ref={editorRef}
          initialCleanHtml={initialCleanHtml}
          hasToolbar
          label={<Trans id="answer-create-field-template">Template</Trans>}
          renderPlaceholder={() => (
            <Trans id="answer-create-field-template-placeholder">Type something you send often</Trans>
          )}
          onChange={onBodyChange}
        />
      )}
    </AnswerDialogBase>
  );
};
